export enum UnitSystemChoice {
    si = 'SI',
    imperial = 'Imperial/US'
}
